import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getServiceDiscoveryList } from '@/services/serviceDiscoveryService';

const initialState = {
  serviceDiscoveryList: [],
  loading: false,
};

export const fetchServiceDiscoveryList = createAsyncThunk(
  'serviceDiscovery/fetchServiceDiscoveryList',
  async () => {
    const response = await getServiceDiscoveryList();
    return response.data;
  },
);

export const serviceDiscoverySlice = createSlice({
  name: 'serviceDiscovery',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceDiscoveryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchServiceDiscoveryList.fulfilled, (state, action) => {
        const discoveryList = action.payload;
        const list = discoveryList.map((item) => {
          const clusterInfo = {
            clusterName: item.primaryClusterName,
            clusterDisplayName: item.primaryClusterDisplayName,
            brokerUrl: item.primaryBrokerUrl,
            inUse: item.primaryClusterName === item.currentProvideServiceCluster,
          };
          const recoveryCluster = {
            clusterName: item.recoveryClusterName,
            brokerUrl: item.recoveryBrokerUrl,
            clusterDisplayName: item.recoveryClusterDisplayName,
            inUse: item.recoveryClusterName === item.currentProvideServiceCluster,
          };

          return {
            clusterInfo,
            recoveryCluster,
          };
        });
        state.serviceDiscoveryList = list;
        state.loading = false;
      })
      .addCase(fetchServiceDiscoveryList.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default serviceDiscoverySlice.reducer;
